<template>
    <div v-if="atp && atp.laudo && atp.laudo.arquivos && atp.laudo.arquivos.length" class="mb-3">
        <div class="d-flex flex-column mb-1" v-for="(arq, iax) in atp.laudo.arquivos" :key="iax">
            <a v-if="arq.st_tipo_especial != 'audio'" :href="arq.arquivo.temporary_url" class="btn btn-lg" :class="arq.st_tipo_especial == 'anexo' ? 'btn-outline-secondary' : 'btn-outline-primary'" target="_blank">
                <template v-if="arq.st_tipo_especial == 'anexo'">
                    <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>    
                    Anexo
                </template>
                <template v-else>
                    <i class="fa fa-print mr-2" aria-hidden="true"></i>
                    Visualizar Laudo
                </template>
                <span class="badge ml-5" :class="arq.st_tipo_especial == 'anexo' ? 'badge-secondary' : 'badge-primary'">
                    <i class="fa-solid fa-key mr-2" v-if="arq.fl_key"></i>
                    {{ arq.arquivo.st_titulo }}
                </span>
            </a>
            <div class="btn btn-lg d-flex justify-content-center align-items-center" :class="iax === audio_selecionado ? 'btn-primary' : 'btn-outline-primary'" @click="selec_audio(iax)" v-else>
                {{ arq.arquivo.st_titulo }}
                <audio 
                    :ref="'audio' + iax"
                    class="ml-2 w-50"
                    :src="arq.arquivo.temporary_url"
                    style="height: 30px;"
                    controls
                    controlsList="nodownload"
                ></audio>
            </div>

            <audio-player :src="arq.arquivo.temporary_url" v-if="false && arq.st_tipo_especial == 'audio'" />
        </div>

        <div v-if="audio_selec" class="text-center small text-muted">
            <span><strong>Ctrl + Espaço</strong> para play/pause</span>
            <span class="mx-5"><strong>Ctrl + &lt;</strong> para -3s</span> 
            <span><strong>Ctrl + &gt;</strong> para +3s.</span>
        </div>
        
    </div>
</template>

<script>
import AudioPlayer from './AudioPlayer.vue';
export default {
    data() { 
        return { 
            audio_selecionado: null, 
            lastSilence: null, 
        }
    },

    props: ['atp'], 

    components: {
        AudioPlayer
    },

    computed: { 
        audio_selec: function() {
            if (this.audio_selecionado === null) return null;

            if ( this.$refs['audio' + this.audio_selecionado] ) { 
                return this.$refs['audio' + this.audio_selecionado][0];
            }

            return null; 
        }
    }, 

    beforeDestroy(){
        if ( this.audio_selec ) { 
            document.removeEventListener("keydown",this.shortcuts)
        }
    },

    methods: { 
        selec_audio(iax){
            document.removeEventListener("keydown",this.shortcuts);

            if ( this.audio_selecionado === iax) {
                this.audio_selecionado = null;
            } else {
                this.audio_selecionado = iax;
                document.addEventListener("keydown",this.shortcuts);
            }
        }, 

        shortcuts(e){

            if(!e.ctrlKey) return;

            switch(e.key){

                case " ":
                    e.preventDefault()
                    this.toggle()
                    break

                case ",":
                    this.rewind()
                    break

                case ".":
                    this.forward()
                    break

            }

        },

        toggle(){

            if ( !this.audio_selec ) 
                return;

            if(this.audio_selec.paused){

                this.audio_selec.play();
                // this.playing=true;

            }else{

                this.smartPause();

            }

        },

        smartPause(){

            if ( !this.audio_selec ) 
                return;

            this.audio_selec.pause();

            if(this.lastSilence){

                this.audio_selec.currentTime=this.lastSilence

            }

            // this.playing=false

        },

        rewind(){

            if ( !this.audio_selec ) 
                return;

            this.audio_selec.currentTime=Math.max(
                0,
                this.audio_selec.currentTime-3
            )

        },

        forward(){

            if ( !this.audio_selec ) 
                return;

            this.audio_selec.currentTime=Math.min(
                this.audio_selec.duration,
                this.audio_selec.currentTime+3
            )

        },
    }
}
</script>
